import { Card, Text } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { dateTimeFormatter } from '../../../../utils/format-date';
import { useStorefrontOptionsControls } from '../../context/storefront-options-context';

const CARD =
  'features:storefront_options.pages.storefront_options_page.publish_status' satisfies I18nPrefix;

type Status = 'never_published' | 'unpublished_changes' | 'up_to_date';

const STATUS_BADGES = {
  never_published: 'white',
  unpublished_changes: 'yellow',
  up_to_date: 'green',
} as const;

export function PublishStatusCard() {
  const { publishedAt, hasPublished, hasUnpublishedChanges } = useStorefrontOptionsControls();

  const status: Status = !hasPublished
    ? 'never_published'
    : hasUnpublishedChanges
      ? 'unpublished_changes'
      : 'up_to_date';

  const publishedOn = publishedAt ? dateTimeFormatter.format(new Date(publishedAt)) : null;
  const statusText = publishedOn
    ? t(`${CARD}.${status}`, { date: publishedOn })
    : t(`${CARD}.never_published`);

  return (
    <Card>
      <Card.Header
        headingLevel="h2"
        badges={[{ text: t(`${CARD}.badge.${status}`), variant: STATUS_BADGES[status] }]}
      >
        {t(`${CARD}.title`)}
      </Card.Header>
      <Card.Body>
        <Text size="sm" variant="secondary">
          {statusText}
        </Text>
      </Card.Body>
    </Card>
  );
}
